import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { AppGenericResourcesHdrContainerModel } from '../../../../../../models/aggregates/generic-resources/app-generic-resources-hdr.model';
import { ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../../shared';

@Injectable({ 
  providedIn: 'root' 
})

export class AppGenericResourcesHdrService extends BaseApiTemplateService<AppGenericResourcesHdrContainerModel>{

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-generic-resources-hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-generic-resources-hdrs';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'app-generic-resources-hdrs';
    this.httpClient = http;
  }

  getByCriteriaAsSysAdmin(pagination: Pagination, apiVisa : ApiVisa){
    this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/query?' + pagination.getQueryKeyValues();
    
    return this.httpClient.get<PagingResponseModel<AppGenericResourcesHdrContainerModel>>(
        this.apiUrl,
        this.getHttpHeader(apiVisa)
    );
  }

  getByGuidAsSysAdmin(guid: string, apiVisa: ApiVisa){
    this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/sysadmin-ep/' + guid

    return this.httpClient.get<BasicApiResponseModel<AppGenericResourcesHdrContainerModel>>(
        this.apiUrl,
        this.getHttpHeader(apiVisa)
    );
  }
}